import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { trackPromise } from "react-promise-tracker";
import Spinner from '../../common/components/Spinner';
import { RiFileExcel2Fill, RiFileZipFill } from 'react-icons/ri';
import { FaMinusSquare, FaPlusSquare, FaSearch, FaFolderOpen, FaExpandAlt, FaCompressAlt } from 'react-icons/fa';
import QuadrosModal from './QuadrosModal';
import { styles } from './ReportStudiesStyles';
import { SOFTDATANODEJS } from '../../config';

const ReportStudiesTable = () => {
    const [data, setData] = useState([]);
    const [pageSize, setPageSize] = useState(50);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [collapsedGroups, setCollapsedGroups] = useState({});

    const [selectedEstudo, setSelectedEstudo] = useState(null);
    const [showViewModal, setShowViewModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editData, setEditData] = useState(null);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [createData, setCreateData] = useState({ nome: '', abr: '', grupoId: '', chart_palete: 0, estado: 1, desc: '', idiomaId: 1, valorUniv: '' });

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [estudoToDelete, setEstudoToDelete] = useState(null);
    const [showDuplicateModal, setShowDuplicateModal] = useState(false);
    const [estudoToDuplicate, setEstudoToDuplicate] = useState(null);

    const [showImportModal, setShowImportModal] = useState(false);
    const [estudoToImport, setEstudoToImport] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [importResult, setImportResult] = useState(null);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    // --- STATE PARA IMPORTAÇÃO MÚLTIPLA DE ZIPs HTML ---
    const [showZipImportModal, setShowZipImportModal] = useState(false);
    const [selectedZipFiles, setSelectedZipFiles] = useState([]);
    const [zipImportResult, setZipImportResult] = useState(null);

    const [showQuadrosModal, setShowQuadrosModal] = useState(false);
    const [currentEstudoQuadros, setCurrentEstudoQuadros] = useState(null);

    useEffect(() => { fetchData(); }, []);

    const fetchData = async () => {
        try {
            const url = `${SOFTDATANODEJS}/lista-estudos`;
            const response = await trackPromise(axios.get(url));
            setData(response.data);
        } catch (error) {
            setErrorMessage("Erro ao obter a lista de estudos.");
            setShowErrorModal(true);
        }
    };

    const handleToggleAllCollapse = () => {
        const allGroupsCount = data.length;
        const collapsedCount = Object.values(collapsedGroups).filter(Boolean).length;
        const isAllCollapsed = allGroupsCount > 0 && collapsedCount === allGroupsCount;

        const newState = {};
        if (!isAllCollapsed) {
            data.forEach(g => newState[g.grupo_id] = true);
        }
        setCollapsedGroups(newState);
    };

    const processDisplayList = () => {
        let displayList = [];
        data.forEach(group => {
            const term = searchTerm.toLowerCase();
            const groupMatches = group.grupo.toLowerCase().includes(term);

            const matchingStudies = group.estudos.filter(e =>
                String(e.id).includes(term) ||
                e.nome.toLowerCase().includes(term) ||
                (e.abr && e.abr.toLowerCase().includes(term)) ||
                groupMatches
            );

            if (matchingStudies.length === 0 && !groupMatches) return;
            displayList.push({ type: 'HEADER', id: `g-${group.grupo_id}`, grupoId: group.grupo_id, grupoName: group.grupo, count: matchingStudies.length });

            if (!collapsedGroups[group.grupo_id]) {
                matchingStudies.forEach(estudo => {
                    displayList.push({ type: 'ROW', id: estudo.id, data: { ...estudo, grupoId: group.grupo_id, grupo_name: group.grupo } });
                });
            }
        });
        return displayList;
    };

    const fullList = processDisplayList();
    const totalItems = fullList.length;
    const totalPages = Math.ceil(totalItems / pageSize);
    const indexOfLastItem = currentPage * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    const currentItems = fullList.slice(indexOfFirstItem, indexOfLastItem);

    const toggleCollapse = (groupId) => setCollapsedGroups(prev => ({ ...prev, [groupId]: !prev[groupId] }));

    const handleCreateClick = () => {
        const defaultGroup = data.length > 0 ? data[0].grupo_id : '';
        setCreateData({ nome: '', abr: '', grupoId: defaultGroup, chart_palete: 0, estado: 1, desc: '', idiomaId: 1, valorUniv: '' });
        setShowCreateModal(true);
    };

    const handleCreateSave = async () => {
        try {
            const payload = { ...createData, valorUniv: createData.valorUniv === '' ? null : parseInt(createData.valorUniv, 10) };
            await trackPromise(axios.post(`${SOFTDATANODEJS}/estudo`, payload));
            setShowCreateModal(false);
            fetchData();
            setShowSuccessModal(true);
        } catch (err) {
            // Tenta ir buscar a mensagem de erro real do Node.js
            const msg = err.response?.data?.error || "Erro ao criar o estudo. Verifique a ligação ao servidor.";
            setErrorMessage(msg);
            setShowErrorModal(true);
        }
    };

    const handleSaveEdit = async () => {
        try {
            const payload = { ...editData, valorUniv: editData.valorUniv === '' ? null : parseInt(editData.valorUniv, 10) };
            await trackPromise(axios.put(`${SOFTDATANODEJS}/estudo/${editData.id}`, payload));
            setShowEditModal(false); fetchData();
        } catch (err) {
            setErrorMessage("Erro ao guardar as alterações.");
            setShowErrorModal(true);
        }
    };

    const handleOpenQuadros = (estudo) => {
        setCurrentEstudoQuadros(estudo);
        setShowQuadrosModal(true);
    };

    const handleAction = (id, actionType) => {
        let targetEstudo = null, targetGroup = null;
        for (const g of data) { const found = g.estudos.find(e => e.id === id); if (found) { targetEstudo = found; targetGroup = g; break; } }
        if (!targetEstudo) return;
        const estudoWithGroupInfo = { ...targetEstudo, desc: targetEstudo.desc || '', grupoId: targetGroup.grupo_id, grupo_name: targetGroup.grupo };

        switch (actionType) {
            case 'open-quadros': handleOpenQuadros(estudoWithGroupInfo); break;
            case 'view': setSelectedEstudo(estudoWithGroupInfo); setShowViewModal(true); break;
            case 'edit': setEditData({ ...estudoWithGroupInfo }); setShowEditModal(true); break;
            case 'delete': setEstudoToDelete(estudoWithGroupInfo); setShowDeleteModal(true); break;
            case 'duplicate': setEstudoToDuplicate(estudoWithGroupInfo); setShowDuplicateModal(true); break;
            case 'import-excel': setEstudoToImport(estudoWithGroupInfo); setSelectedFile(null); setImportResult(null); setShowImportModal(true); break;
            case 'import-zip-html':
                setEstudoToImport(estudoWithGroupInfo);
                setSelectedZipFiles([]);
                setZipImportResult(null);
                setShowZipImportModal(true);
                break;
            default: break;
        }
    };

    const confirmDelete = async () => {
        if (!estudoToDelete) return;
        try {
            await trackPromise(axios.delete(`${SOFTDATANODEJS}/estudo/${estudoToDelete.id}`));
            setShowDeleteModal(false); fetchData();
        } catch (err) {
            setErrorMessage("Erro ao eliminar.");
            setShowErrorModal(true);
        }
    };

    const confirmDuplicate = async () => {
        if (!estudoToDuplicate) return;
        try {
            await trackPromise(axios.post(`${SOFTDATANODEJS}/estudo/duplicate/${estudoToDuplicate.id}`));
            setShowDuplicateModal(false); fetchData();
        } catch (err) {
            setErrorMessage("Erro ao duplicar.");
            setShowErrorModal(true);
        }
    };

    const handleImportSubmit = async () => {
        if (!selectedFile || !estudoToImport) return;

        const formData = new FormData();
        formData.append('file', selectedFile);
        formData.append('estudoId', estudoToImport.id);
        formData.append('quadroPaiId', 0);

        try {
            const response = await trackPromise(
                axios.post(`${SOFTDATANODEJS}/estudo/import-excel`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
            );

            const imported = response.data.imported ?? 0;

            setImportResult({
                success: true,
                message: imported === 1
                    ? 'Excel importado com sucesso. Foi importado 1 quadro.'
                    : `Excel importado com sucesso. Foram importados ${imported} quadros.`,
                imported,
                skippedCount: response.data.skippedCount ?? 0,
                warnings: response.data.warnings || []
            });

        } catch (err) {
            const apiError = err.response?.data || {};

            setImportResult({
                success: false,

                message:
                    apiError.message ||
                    apiError.error ||
                    'Erro ao importar ficheiro Excel.',

                imported: apiError.imported ?? 0,
                validatedBeforeFailure: apiError.validatedBeforeFailure ?? null,

                skippedCount: apiError.skippedCount ?? 0,
                skippedSheetCount: apiError.skippedSheetCount ?? apiError.skippedCount ?? 0,
                skippedErrorCount: apiError.skippedErrorCount ?? 0,

                skipped: apiError.skipped || [],
                skippedBySheet: apiError.skippedBySheet || [],
                skippedSummary: apiError.skippedSummary || [],

                warnings: apiError.warnings || [],

                sheetName: apiError.sheetName || null,
                row: apiError.row ?? null,
                col: apiError.col ?? null,
                cell: apiError.cell || null
            });
        }
    };

    // --- SUBMIT PARA MÚLTIPLOS ZIPs ---
    const handleZipImportSubmit = async () => {
        if (!selectedZipFiles?.length || !estudoToImport) return;

        const formData = new FormData();
        // ⚠️ TEXTO ANTES DOS FICHEIROS PARA O MULTER LER BEM
        formData.append('estudoId', estudoToImport.id);
        selectedZipFiles.forEach(file => formData.append('files', file));

        try {
            const response = await trackPromise(
                axios.post(`${SOFTDATANODEJS}/estudo/import-html-zips`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            );
            setZipImportResult({ success: true, message: response.data.message || `${selectedZipFiles.length} ficheiros ZIP importados com sucesso.` });
        } catch (err) {
            const apiError = err.response?.data || {};
            setZipImportResult({ success: false, message: apiError.error || "Erro de comunicação com o servidor. Verifique o SFTP." });
        }
    };

    const closeImportModal = () => { setShowImportModal(false); setShowZipImportModal(false); if (importResult?.success || zipImportResult?.success) fetchData(); setImportResult(null); setZipImportResult(null); };

    // --- RENDER ---
    return (
        <div style={styles.pageBackground}>
            <Spinner />

            <div style={styles.container}>
                <div style={styles.headerBar}>
                    <div style={{ flex: 1 }}></div>
                    <h2 style={styles.mainTitle}>Lista de Estudos</h2>
                    <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end', paddingRight: '10px' }}>
                        <button
                            style={{
                                ...styles.footerBtn,
                                height: '34px',
                                boxSizing: 'border-box',
                                padding: '0 15px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                background: '#28a745',
                                color: '#fff',
                                border: 'none',
                                fontWeight: 'bold',
                                margin: 0,
                                whiteSpace: 'nowrap'
                            }}
                            onClick={handleCreateClick}
                        >
                            <FaPlusSquare size={16} />
                            <span>Novo Estudo</span>
                        </button>
                    </div>
                </div>

                <div style={styles.controls}>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                        <div style={{ ...styles.searchBox, height: '34px', minHeight: '34px', maxHeight: '34px', boxSizing: 'border-box', margin: 0, padding: '0 8px' }}>
                            <FaSearch style={{ color: '#666', marginRight: '5px' }} />
                            <input
                                placeholder="Pesquisar estudo (Nome, ID...)"
                                value={searchTerm}
                                onChange={e => { setSearchTerm(e.target.value); setCurrentPage(1); }}
                                style={{ ...styles.searchInput, margin: 0, height: '100%', boxSizing: 'border-box', backgroundColor: 'transparent' }}
                            />
                        </div>

                        {(() => {
                            const isAllCollapsed = data.length > 0 && Object.values(collapsedGroups).filter(Boolean).length === data.length;
                            return (
                                <button
                                    style={{ ...styles.footerBtn, height: '34px', minHeight: '34px', maxHeight: '34px', boxSizing: 'border-box', padding: '0 12px', display: 'flex', alignItems: 'center', gap: '6px', color: '#005c75', border: '1px solid #005c75', backgroundColor: '#e2f3f5', fontWeight: 'bold', margin: 0 }}
                                    onClick={handleToggleAllCollapse}
                                >
                                    {isAllCollapsed ? <FaExpandAlt size={14} /> : <FaCompressAlt size={14} />}
                                    {isAllCollapsed ? 'Expandir Tudo' : 'Colapsar Tudo'}
                                </button>
                            );
                        })()}
                    </div>
                    <div style={styles.paginationGroup}>
                        <button style={styles.navBtn} disabled={currentPage === 1} onClick={() => setCurrentPage(prev => prev - 1)}>Anterior</button><span style={styles.pageIndicator}>Pág. {currentPage} de {totalPages || 1}</span><button style={styles.navBtn} disabled={currentPage >= totalPages} onClick={() => setCurrentPage(prev => prev + 1)}>Próximo</button><div style={styles.countDisplay}>&nbsp;| {totalItems > 0 ? indexOfFirstItem + 1 : 0} - {Math.min(indexOfLastItem, totalItems)} de {totalItems} items</div><select style={styles.select} value={pageSize} onChange={(e) => { setPageSize(Number(e.target.value)); setCurrentPage(1); }}><option value={20}>20</option><option value={50}>50</option><option value={100}>100</option></select></div>
                </div>

                <div style={styles.tableContainer}>
                    <table style={styles.table}>
                        <thead style={styles.theadSticky}>
                            <tr style={styles.theadRow}>
                                <th style={{ ...styles.th, width: '90px' }}>ID</th>
                                <th style={{ ...styles.th, width: '100px' }}>Abr.</th>
                                <th style={styles.th}>Nome</th>
                                <th style={{ ...styles.th, width: '100px' }}>Estado</th>
                                <th style={{ ...styles.th, width: '320px' }}>Acções</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(() => {
                                let zebraCounter = 0;

                                return currentItems.map((item) => {
                                    if (item.type === 'HEADER') {
                                        zebraCounter = 0;
                                        const isCollapsed = collapsedGroups[item.grupoId];
                                        return (
                                            <tr key={item.id} style={styles.groupHeaderRow}>
                                                <td colSpan="5" style={styles.groupTd}>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <span onClick={() => toggleCollapse(item.grupoId)} style={{ cursor: 'pointer', marginRight: '10px', display: 'flex', alignItems: 'center' }}>{isCollapsed ? <FaPlusSquare size={16} /> : <FaMinusSquare size={16} />}</span>
                                                        {item.grupoName} <span style={{ fontWeight: 'normal', fontSize: '12px', marginLeft: '10px' }}>({item.count} Estudos)</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    } else {
                                        const isEven = zebraCounter % 2 === 0;
                                        zebraCounter++;
                                        const estudo = item.data;

                                        return (
                                            <tr key={item.id} style={{ ...styles.dataRow, backgroundColor: isEven ? '#ffffff' : '#f0f4f8' }}>
                                                <td style={styles.td}>{estudo.id}</td><td style={styles.td}>{estudo.abr || ''}</td><td style={{ ...styles.td, textAlign: 'left' }}>{estudo.nome}</td><td style={{ ...styles.td, color: estudo.estado === 1 ? '#28a745' : '#dc3545', fontWeight: 'bold' }}>{estudo.estado === 1 ? 'ACTIVO' : 'INACTIVO'}</td>
                                                <td style={styles.tdActions}>
                                                    <button style={styles.iconBtn} onClick={() => handleAction(estudo.id, 'open-quadros')} title="Mostrar Ficha (Quadros)"><FaFolderOpen style={{ color: '#007bff' }} /></button>
                                                    <button style={styles.iconBtn} onClick={() => handleAction(estudo.id, 'view')} title="Visualizar">👁</button>
                                                    <button style={styles.iconBtn} onClick={() => handleAction(estudo.id, 'edit')} title="Editar">✎</button>
                                                    <button style={styles.iconBtn} onClick={() => handleAction(estudo.id, 'delete')} title="Eliminar">🗑</button>
                                                    <button style={styles.iconBtn} onClick={() => handleAction(estudo.id, 'duplicate')} title="Duplicar">📋</button>
                                                    <button style={styles.iconBtn} onClick={() => handleAction(estudo.id, 'import-excel')} title="Importar XLSX"><RiFileExcel2Fill style={{ color: '#1D6F42', fontSize: '18px' }} /></button>

                                                    {/* BOTÃO MÚLTIPLOS ZIPs NO ESTUDO */}
                                                    <button style={styles.iconBtn} onClick={() => handleAction(estudo.id, 'import-zip-html')} title="Importar Múltiplos ZIPs"><RiFileZipFill style={{ color: '#005c75', fontSize: '18px' }} /></button>
                                                </td>
                                            </tr>
                                        );
                                    }
                                });
                            })()}
                        </tbody>
                    </table>
                </div>
            </div>

            {showQuadrosModal && currentEstudoQuadros && (
                <QuadrosModal estudo={currentEstudoQuadros} onClose={() => setShowQuadrosModal(false)} />
            )}

            {/* --- MODAIS EXISTENTES (CRIAR, VER, EDITAR, DUPLICAR, APAGAR, EXCEL) --- */}
            {showCreateModal && (<div style={styles.modalOverlay}><div style={styles.modalContent}><h2 style={styles.modalTitle}>Criar Novo Estudo</h2><div style={styles.modalScroll}><table style={styles.infoTable}><tbody><tr><td style={styles.infoLabel}>Nome:</td><td style={styles.infoVal}><input style={styles.modalInput} value={createData.nome} onChange={e => setCreateData({ ...createData, nome: e.target.value })} /></td></tr><tr><td style={styles.infoLabel}>Abreviatura:</td><td style={styles.infoVal}><input style={styles.modalInput} value={createData.abr} onChange={e => setCreateData({ ...createData, abr: e.target.value })} /></td></tr><tr><td style={styles.infoLabel}>Grupo:</td><td style={styles.infoVal}><select style={styles.modalInput} value={createData.grupoId} onChange={e => setCreateData({ ...createData, grupoId: Number(e.target.value) })}>{data.map(g => <option key={g.grupo_id} value={g.grupo_id}>{g.grupo}</option>)}</select></td></tr><tr><td style={styles.infoLabel}>Valor Universal:</td><td style={styles.infoVal}><input type="number" style={styles.modalInput} value={createData.valorUniv} onChange={e => setCreateData({ ...createData, valorUniv: e.target.value })} /></td></tr><tr><td style={styles.infoLabel}>Estado:</td><td style={styles.infoVal}><select style={styles.modalInput} value={createData.estado} onChange={e => setCreateData({ ...createData, estado: Number(e.target.value) })}> <option value={1}>ACTIVO</option><option value={0}>INACTIVO</option></select></td></tr><tr><td style={styles.infoLabel}>Descrição:</td><td style={styles.infoVal}><textarea style={{ ...styles.modalInput, height: '60px' }} value={createData.desc} onChange={e => setCreateData({ ...createData, desc: e.target.value })} /></td></tr></tbody></table></div><div style={styles.modalFooter}><button style={{ ...styles.footerBtn, background: '#28a745', color: 'white' }} onClick={handleCreateSave}>Criar</button><button style={styles.footerBtn} onClick={() => setShowCreateModal(false)}>Cancelar</button></div></div></div>)}
            {showViewModal && selectedEstudo && (<div style={styles.modalOverlay}><div style={styles.modalContent}><h2 style={styles.modalTitle}>Informação do Estudo</h2><table style={styles.infoTable}><thead><tr style={styles.infoSectionHeader}><th colSpan="2">Detalhes</th></tr></thead><tbody><tr><td style={styles.infoLabel}>ID:</td><td style={styles.infoVal}>{selectedEstudo.id}</td></tr><tr><td style={styles.infoLabel}>Nome:</td><td style={styles.infoVal}>{selectedEstudo.nome}</td></tr><tr><td style={styles.infoLabel}>Abreviatura:</td><td style={styles.infoVal}>{selectedEstudo.abr || 'N/A'}</td></tr><tr><td style={styles.infoLabel}>Grupo:</td><td style={styles.infoVal}>{selectedEstudo.grupo_name}</td></tr><tr><td style={styles.infoLabel}>Valor Universal:</td><td style={styles.infoVal}>{selectedEstudo.valorUniv || 'N/A'}</td></tr><tr><td style={styles.infoLabel}>Estado:</td><td style={styles.infoVal}>{selectedEstudo.estado === 1 ? 'ACTIVO' : 'INACTIVO'}</td></tr><tr><td style={styles.infoLabel}>Descrição:</td><td style={styles.infoVal}>{selectedEstudo.desc}</td></tr></tbody></table><div style={styles.modalFooter}><button style={styles.footerBtn} onClick={() => setShowViewModal(false)}>Fechar</button></div></div></div>)}
            {showEditModal && editData && (<div style={styles.modalOverlay}><div style={styles.modalContent}><h2 style={styles.modalTitle}>Editar Estudo: {editData.id}</h2><div style={styles.modalScroll}><table style={styles.infoTable}><tbody><tr><td style={styles.infoLabel}>Nome:</td><td style={styles.infoVal}><input style={styles.modalInput} value={editData.nome} onChange={(e) => setEditData({ ...editData, nome: e.target.value })} /></td></tr><tr><td style={styles.infoLabel}>Abreviatura:</td><td style={styles.infoVal}><input style={styles.modalInput} value={editData.abr || ''} onChange={(e) => setEditData({ ...editData, abr: e.target.value })} /></td></tr><tr><td style={styles.infoLabel}>Grupo:</td><td style={styles.infoVal}><select style={styles.modalInput} value={Number(editData.grupoId)} onChange={(e) => setEditData({ ...editData, grupoId: Number(e.target.value) })}>{data.map(g => (<option key={g.grupo_id} value={g.grupo_id}>{g.grupo}</option>))}</select></td></tr><tr><td style={styles.infoLabel}>Valor Universal:</td><td style={styles.infoVal}><input type="number" style={styles.modalInput} value={editData.valorUniv ?? ''} onChange={(e) => setEditData({ ...editData, valorUniv: e.target.value })} /></td></tr><tr><td style={styles.infoLabel}>Estado:</td><td style={styles.infoVal}><select style={styles.modalInput} value={editData.estado} onChange={(e) => setEditData({ ...editData, estado: Number(e.target.value) })}><option value="1">ACTIVO</option><option value="0">INACTIVO</option></select></td></tr><tr><td style={styles.infoLabel}>Descrição:</td><td style={styles.infoVal}><textarea style={{ ...styles.modalInput, height: '60px' }} value={editData.desc} onChange={(e) => setEditData({ ...editData, desc: e.target.value })} /></td></tr></tbody></table></div><div style={styles.modalFooter}><button style={{ ...styles.footerBtn, background: '#005c75', color: '#fff' }} onClick={handleSaveEdit}>Guardar</button><button style={styles.footerBtn} onClick={() => setShowEditModal(false)}>Cancelar</button></div></div></div>)}
            {showDeleteModal && estudoToDelete && (<div style={styles.modalOverlay}><div style={{ ...styles.modalContent, maxWidth: '400px', textAlign: 'center' }}><h3 style={{ color: '#dc3545' }}>Eliminar Estudo?</h3><p style={{ color: '#333' }}>{estudoToDelete.nome}</p><div style={styles.modalFooterCenter}><button style={{ ...styles.footerBtn, background: '#dc3545', color: 'white' }} onClick={confirmDelete}>Eliminar</button><button style={styles.footerBtn} onClick={() => setShowDeleteModal(false)}>Cancelar</button></div></div></div>)}
            {showDuplicateModal && estudoToDuplicate && (<div style={styles.modalOverlay}><div style={{ ...styles.modalContent, maxWidth: '400px', textAlign: 'center' }}><h3 style={{ color: '#005c75' }}>Duplicar Estudo?</h3><p style={{ color: '#333' }}>{estudoToDuplicate.nome}</p><div style={styles.modalFooterCenter}><button style={{ ...styles.footerBtn, background: '#005c75', color: 'white' }} onClick={confirmDuplicate}>Confirmar</button><button style={styles.footerBtn} onClick={() => setShowDuplicateModal(false)}>Cancelar</button></div></div></div>)}
            {showImportModal && estudoToImport && (
                <div style={styles.modalOverlay}>
                    <div style={{ ...styles.modalContent, maxWidth: '700px' }}>
                        <h2 style={{ ...styles.modalTitle, borderBottom: '2px solid #1D6F42' }}>
                            Importar Excel
                        </h2>

                        {!importResult ? (
                            <div style={{ padding: '15px' }}>
                                <p style={{ fontSize: '14px', color: '#333' }}>
                                    Importar para: <strong>{estudoToImport.nome}</strong>
                                </p>

                                <div
                                    style={styles.dropZone}
                                    onClick={() => document.getElementById('excel-upload-input').click()}
                                >
                                    <RiFileExcel2Fill
                                        style={{
                                            color: '#1D6F42',
                                            fontSize: '40px',
                                            marginBottom: '10px'
                                        }}
                                    />

                                    <p
                                        style={{
                                            fontSize: '14px',
                                            color: '#1D6F42',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        {selectedFile ? selectedFile.name : 'Clique para selecionar o ficheiro Excel'}
                                    </p>

                                    <input
                                        type="file"
                                        id="excel-upload-input"
                                        style={{ display: 'none' }}
                                        accept=".xlsx, .xls"
                                        onChange={(e) => setSelectedFile(e.target.files[0])}
                                    />
                                </div>

                                <div style={styles.modalFooter}>
                                    <button
                                        style={{
                                            ...styles.footerBtn,
                                            background: selectedFile ? '#1D6F42' : '#ccc',
                                            color: '#fff',
                                            border: 'none'
                                        }}
                                        disabled={!selectedFile}
                                        onClick={handleImportSubmit}
                                    >
                                        Processar
                                    </button>

                                    <button
                                        style={styles.footerBtn}
                                        onClick={() => setShowImportModal(false)}
                                    >
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div style={{ padding: '16px', textAlign: 'center' }}>
                                {importResult.success ? (
                                    <div style={{ color: 'green', fontSize: '16px' }}>
                                        <p style={{ fontSize: '40px' }}>✅</p>
                                        <strong>Sucesso!</strong>
                                        <p>{importResult.message}</p>
                                        {importResult.imported !== undefined && (
                                            <div
                                                style={{
                                                    marginTop: '12px',
                                                    padding: '10px',
                                                    background: '#eaf7ea',
                                                    border: '1px solid #badbcc',
                                                    borderRadius: '4px',
                                                    color: '#0f5132',
                                                    fontSize: '14px',
                                                    textAlign: 'left'
                                                }}
                                            >
                                                <div>
                                                    <strong>Quadros importados:</strong>{' '}
                                                    {importResult.imported}
                                                </div>

                                                {importResult.skippedCount > 0 && (
                                                    <div>
                                                        <strong>Folhas ignoradas:</strong>{' '}
                                                        {importResult.skippedCount}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        {importResult.warnings && importResult.warnings.length > 0 && (
                                            <div
                                                style={{
                                                    marginTop: '15px',
                                                    padding: '10px',
                                                    background: '#fff3cd',
                                                    color: '#856404',
                                                    borderRadius: '4px',
                                                    border: '1px solid #ffeeba',
                                                    fontSize: '14px',
                                                    textAlign: 'left',
                                                    maxHeight: '110px',
                                                    overflowY: 'auto'
                                                }}
                                            >
                                                <strong>⚠️ Avisos na importação:</strong>

                                                <ul style={{ margin: '8px 0 0 20px', padding: 0 }}>
                                                    {importResult.warnings.map((w, i) => (
                                                        <li key={i} style={{ marginBottom: '6px' }}>
                                                            {w}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div style={{ color: '#dc3545', fontSize: '16px' }}>
                                        <p style={{ fontSize: '40px' }}>❌</p>
                                        <strong>Erro na Importação</strong>

                                        <p style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                            {importResult.message}
                                        </p>

                                        {importResult.imported !== undefined && (
                                            <div
                                                style={{
                                                    marginTop: '12px',
                                                    padding: '10px',
                                                    background: '#fff3cd',
                                                    border: '1px solid #ffeeba',
                                                    borderRadius: '4px',
                                                    color: '#856404',
                                                    fontSize: '14px',
                                                    textAlign: 'left'
                                                }}
                                            >
                                                <div>
                                                    <strong>Quadros processados antes do erro:</strong>{' '}
                                                    {importResult.validatedBeforeFailure ?? importResult.imported ?? 0}
                                                </div>

                                                <div>
                                                    <strong>Folhas com erro:</strong>{' '}
                                                    {importResult.skippedSheetCount ?? importResult.skippedCount ?? 0}
                                                </div>

                                                <div>
                                                    <strong>Erros encontrados:</strong>{' '}
                                                    {importResult.skippedErrorCount ?? importResult.skipped?.length ?? 0}
                                                </div>

                                                <div style={{ marginTop: '6px' }}>
                                                    <strong>Nota:</strong> a importação foi cancelada e revertida para evitar importação parcial.
                                                </div>
                                            </div>
                                        )}

                                        {importResult.skippedBySheet && importResult.skippedBySheet.length > 0 && (
                                            <div
                                                style={{
                                                    marginTop: '12px',
                                                    padding: '10px',
                                                    background: '#fff5f5',
                                                    border: '1px solid #f5c2c7',
                                                    borderRadius: '4px',
                                                    textAlign: 'left',
                                                    color: '#842029',
                                                    fontSize: '14px',
                                                    maxHeight: '150px',
                                                    overflowY: 'auto'
                                                }}
                                            >
                                                <strong>Erros encontrados:</strong>

                                                <div style={styles.importErrorsList ?? { marginTop: '8px' }}>
                                                    {importResult.skippedBySheet.map((sheet, sheetIndex) => (
                                                        <div
                                                            key={sheetIndex}
                                                            style={styles.importErrorSheet ?? { marginBottom: '10px' }}
                                                        >
                                                            <div
                                                                style={
                                                                    styles.importErrorSheetTitle ?? {
                                                                        fontWeight: 'bold',
                                                                        marginBottom: '4px'
                                                                    }
                                                                }
                                                            >
                                                                {sheetIndex + 1}. Folha "{sheet.sheetName}" — {sheet.errorCount} erro(s):
                                                            </div>

                                                            <ul
                                                                style={
                                                                    styles.importErrorSublist ?? {
                                                                        margin: '4px 0 0 18px',
                                                                        padding: 0
                                                                    }
                                                                }
                                                            >
                                                                {sheet.errors.map((err, errIndex) => {
                                                                    const location = err.cell
                                                                        ? `célula ${err.cell}`
                                                                        : (
                                                                            err.row !== null && err.row !== undefined &&
                                                                                err.col !== null && err.col !== undefined
                                                                                ? `linha ${err.row}, coluna ${err.col}`
                                                                                : 'local não identificado'
                                                                        );

                                                                    return (
                                                                        <li
                                                                            key={errIndex}
                                                                            style={
                                                                                styles.importErrorSublistItem ?? {
                                                                                    marginBottom: '4px'
                                                                                }
                                                                            }
                                                                        >
                                                                            {location}: {err.error}
                                                                        </li>
                                                                    );
                                                                })}
                                                            </ul>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        {(!importResult.skippedBySheet || importResult.skippedBySheet.length === 0) &&
                                            (!importResult.skippedSummary || importResult.skippedSummary.length === 0) &&
                                            (
                                                importResult.sheetName ||
                                                (importResult.row !== null && importResult.row !== undefined) ||
                                                (importResult.col !== null && importResult.col !== undefined) ||
                                                importResult.cell
                                            ) && (
                                                <div
                                                    style={{
                                                        marginTop: '12px',
                                                        padding: '10px',
                                                        background: '#fff5f5',
                                                        border: '1px solid #f5c2c7',
                                                        borderRadius: '4px',
                                                        textAlign: 'left',
                                                        color: '#842029',
                                                        fontSize: '14px'
                                                    }}
                                                >
                                                    <strong>Erros encontrados:</strong>

                                                    <ul
                                                        style={
                                                            styles.importErrorSublist ?? {
                                                                margin: '8px 0 0 20px',
                                                                padding: 0
                                                            }
                                                        }
                                                    >
                                                        {importResult.skippedSummary.map((msg, index) => (
                                                            <li
                                                                key={index}
                                                                style={
                                                                    styles.importErrorSublistItem ?? {
                                                                        marginBottom: '6px'
                                                                    }
                                                                }
                                                            >
                                                                {msg}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}

                                        {(!importResult.skippedBySheet || importResult.skippedBySheet.length === 0) &&
                                            (!importResult.skippedSummary || importResult.skippedSummary.length === 0) &&
                                            (importResult.sheetName ||
                                                (importResult.row !== null && importResult.row !== undefined) ||
                                                (importResult.col !== null && importResult.col !== undefined) ||
                                                importResult.cell) && (
                                                <div
                                                    style={{
                                                        marginTop: '12px',
                                                        padding: '10px',
                                                        background: '#fff5f5',
                                                        border: '1px solid #f5c2c7',
                                                        borderRadius: '4px',
                                                        textAlign: 'left',
                                                        color: '#842029',
                                                        fontSize: '14px'
                                                    }}
                                                >
                                                    {importResult.sheetName && (
                                                        <div>
                                                            <strong>Sheet:</strong> {importResult.sheetName}
                                                        </div>
                                                    )}

                                                    {importResult.row !== null && importResult.row !== undefined && (
                                                        <div>
                                                            <strong>Linha:</strong> {importResult.row}
                                                        </div>
                                                    )}

                                                    {importResult.col !== null && importResult.col !== undefined && (
                                                        <div>
                                                            <strong>Coluna:</strong> {importResult.col}
                                                        </div>
                                                    )}

                                                    {importResult.cell && (
                                                        <div>
                                                            <strong>Célula:</strong> {importResult.cell}
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                        {importResult.warnings && importResult.warnings.length > 0 && (
                                            <div
                                                style={{
                                                    marginTop: '12px',
                                                    padding: '10px',
                                                    background: '#fff3cd',
                                                    border: '1px solid #ffeeba',
                                                    borderRadius: '4px',
                                                    textAlign: 'left',
                                                    color: '#856404',
                                                    fontSize: '13px',
                                                    maxHeight: '120px',
                                                    overflowY: 'auto'
                                                }}
                                            >
                                                <strong>⚠️ Avisos encontrados antes do erro:</strong>

                                                <ul style={{ margin: '8px 0 0 20px', padding: 0 }}>
                                                    {importResult.warnings.map((msg, index) => (
                                                        <li key={index} style={{ marginBottom: '6px' }}>
                                                            {msg}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                )}

                                <div style={{ marginTop: '20px' }}>
                                    <button style={styles.footerBtn} onClick={closeImportModal}>
                                        Fechar
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
            {showSuccessModal && (
                <div style={styles.modalOverlay}>
                    <div style={{ ...styles.modalContent, maxWidth: '400px', textAlign: 'center' }}>
                        <div style={{ color: 'green', fontSize: '16px', padding: '15px' }}>
                            <p style={{ fontSize: '40px', margin: '0 0 10px 0' }}>✅</p>
                            <strong>Sucesso!</strong>
                            <p style={{ color: '#333', marginTop: '10px' }}>Estudo criado com sucesso!</p>
                        </div>
                        <div style={styles.modalFooterCenter}>
                            <button style={styles.footerBtn} onClick={() => setShowSuccessModal(false)}>Fechar</button>
                        </div>
                    </div>
                </div>
            )}
            {/* --- MODAL: ERRO NA OPERAÇÃO --- */}
            {showErrorModal && (
                <div style={styles.modalOverlay}>
                    <div style={{ ...styles.modalContent, maxWidth: '400px', textAlign: 'center' }}>
                        <div style={{ color: '#dc3545', fontSize: '16px', padding: '15px' }}>
                            <p style={{ fontSize: '40px', margin: '0 0 10px 0' }}>❌</p>
                            <strong>Erro na Operação</strong>
                            <p style={{ color: '#333', marginTop: '10px', fontSize: '14px' }}>{errorMessage}</p>
                        </div>
                        <div style={styles.modalFooterCenter}>
                            <button
                                style={{ ...styles.footerBtn, background: '#dc3545', color: 'white', border: 'none' }}
                                onClick={() => setShowErrorModal(false)}
                            >
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {/* --- NOVA MODAL: IMPORTAR ZIPs MÚLTIPLOS (NÍVEL ESTUDO) --- */}
            {showZipImportModal && estudoToImport && (
                <div style={styles.modalOverlay}>
                    <div style={{ ...styles.modalContent, maxWidth: '600px' }}>
                        <h2 style={{ ...styles.modalTitle, borderBottom: '2px solid #005c75' }}>Importar ZIPs Múltiplos</h2>
                        {!zipImportResult ? (
                            <div style={{ padding: '15px' }}>
                                <div style={{ marginBottom: 15, background: '#e2f3f5', padding: 10, borderRadius: 4, color: '#005c75', fontSize: '13px', border: '1px solid #b8daff' }}>
                                    <strong>ℹ️ Nota:</strong> Os ficheiros selecionados serão transferidos para o repositório Linux na pasta do estudo. Se o nome do ZIP corresponder ao ID de um quadro, a associação será feita automaticamente.
                                </div>

                                <p style={{ fontSize: '14px', color: '#333' }}>Importar para o estudo: <br /><strong>{estudoToImport.nome}</strong></p>
                                <div style={{ ...styles.dropZone, borderColor: '#005c75' }} onClick={() => document.getElementById('zip-upload-input').click()}>
                                    <RiFileZipFill style={{ color: '#005c75', fontSize: '40px', marginBottom: '10px' }} />
                                    <p style={{ fontSize: '14px', color: '#005c75', fontWeight: 'bold' }}>
                                        {selectedZipFiles?.length > 0 ? `${selectedZipFiles.length} ficheiro(s) ZIP selecionado(s)` : "Clique para selecionar VÁRIOS ficheiros .zip"}
                                    </p>
                                    <input type="file" id="zip-upload-input" multiple style={{ display: 'none' }} accept=".zip" onChange={(e) => setSelectedZipFiles(Array.from(e.target.files))} />
                                </div>

                                {selectedZipFiles?.length > 0 && (
                                    <ul style={{ maxHeight: '100px', overflowY: 'auto', fontSize: '12px', color: '#666', textAlign: 'left', background: '#f5f5f5', padding: '10px 25px', borderRadius: '4px' }}>
                                        {selectedZipFiles.map((f, i) => <li key={i}>{f.name}</li>)}
                                    </ul>
                                )}

                                <div style={styles.modalFooter}>
                                    <button style={{ ...styles.footerBtn, background: selectedZipFiles?.length ? '#005c75' : '#ccc', color: '#fff', border: 'none' }} disabled={!selectedZipFiles?.length} onClick={handleZipImportSubmit}>Importar ZIPs</button>
                                    <button style={styles.footerBtn} onClick={() => setShowZipImportModal(false)}>Cancelar</button>
                                </div>
                            </div>
                        ) : (
                            <div style={{ padding: '20px', textAlign: 'center' }}>
                                {zipImportResult.success ? (
                                    <div style={{ color: 'green', fontSize: '16px' }}>
                                        <p style={{ fontSize: '40px' }}>✅</p><strong>Sucesso!</strong><p>{zipImportResult.message}</p>
                                    </div>
                                ) : (
                                    <div style={{ color: '#dc3545', fontSize: '16px' }}>
                                        <p style={{ fontSize: '40px' }}>❌</p><strong>Erro</strong><p>{zipImportResult.message}</p>
                                    </div>
                                )}
                                <div style={{ marginTop: '20px' }}><button style={styles.footerBtn} onClick={closeImportModal}>Fechar</button></div>
                            </div>
                        )}
                    </div>
                </div>
            )}

        </div>
    );
};

export default ReportStudiesTable;